<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content [showDefaultFormFooter]="true">
        <div class="hcol-flex">
            <div class="hcol-40 floatingLabelContainer">
                <p-floatlabel variant="on">
                    <p-select
                        inputId="type"
                        [autoDisplayFirst]="false"
                        [options]="userRoleTypeOptions"
                        formControlName="type"
                        optionLabel="label"
                        optionValue="value"
                        appendTo="body"
                    ></p-select>
                    <label for="type">Type</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <input id="name" type="text" pInputText formControlName="name" />
                    <label for="name">Name</label>
                </p-floatlabel>
                <p-floatlabel variant="on">
                    <input id="description" pInputText formControlName="description" />
                    <label for="description">Description</label>
                </p-floatlabel>
            </div>

            <div class="hcol-60">
                <p-panel [header]="'Route Resources (By feature scope)'" class="with-borders plain-header">
                    <p-tree
                        id="routeResources"
                        [value]="routeResourceTreeNodes"
                        [(selection)]="routeResourceSelectedTreeNodes"
                        scrollHeight="420px"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="36"
                        [indentation]="1"
                        placeholder="Select the route resource(s) for this user role."
                        [filter]="true"
                        [propagateSelectionDown]="true"
                        [propagateSelectionUp]="true"
                        selectionMode="checkbox"
                        [trackBy]="TreeUtils.treeNodeTrackByKey"
                        [loading]="treeLoading"
                    >
                        <ng-template let-node pTemplate="default">
                            <span [pTooltip]="node.data?.description ?? node.label">{{ node.label }}</span>
                        </ng-template></p-tree
                    >
                </p-panel>
            </div>
        </div>
    </app-ibase-cru-modal-content>
</form>
